import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { ConfigService } from './config.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FileService } from './file.service';
import { TranslocoService } from '@ngneat/transloco';
import tinycolor from 'tinycolor2';
import { StyleModel } from 'app/models/style';
import { Observable, catchError, lastValueFrom, map, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BrandingService {
    private readonly USER_KEY = 'loggedUser';
    private style: StyleModel = {};
    private renderer: Renderer2;

    constructor(
        private rendererFactory: RendererFactory2,
        private sanitizer: DomSanitizer,
        private configService: ConfigService,
        private fileService: FileService,
        private translocoService: TranslocoService) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }



    async loadBranding(id: string): Promise<StyleModel> {
        console.log("Caricamento del branding con ID:", id);

        try {
            const config: any = await lastValueFrom(this.configService.getBranding(id));

            if (config) {
                this.style.backgroundColor = config.brdColor1 || this.style.backgroundColor;
                this.style.logoId = config.brdLogo1 || this.style.logoUrl;
                this.style.textColor = config.brdColor2 || this.style.textColor;
                this.style.introductionHtml = config.brdSigninHtml || this.style.introductionHtml;
                this.style.customColor = config.brdColor3 || this.style.customColor;
                this.style.introductionCss = config.brdAppCss || this.style.introductionCss;

                const styleElement = this.renderer.createElement('style');
                const sanitizedCss = this.sanitizer.sanitize(1, this.style.introductionCss);
                this.renderer.setProperty(styleElement, 'textContent', sanitizedCss);
                this.renderer.appendChild(document.head, styleElement);

                this.setCustomColor(this.style.backgroundColor, 'background');
                this.setCustomColor(this.style.textColor, 'text');
                this.setCustomColor(this.style.customColor, 'custom');

                if (this.style.logoId) {
                    const result: any = await lastValueFrom(this.fileService.readFileAsBase64String(this.style.logoId));
                    this.style.logoUrl = result.dataUrl;
                    config.brdLogo1 = result.dataUrl;
                }

                localStorage.setItem('branding', JSON.stringify(config));
                console.log("Branding salvato nel localStorage:", localStorage.getItem('branding'));
            } else {
                console.warn("Branding config è undefined o null");
            }

            return this.style;

        } catch (error) {
            console.error('Errore durante il caricamento del branding:', error);
            throw error;
        }
    }

    setCustomColor(color: string, name: string): void {
        document.documentElement.style.setProperty(`--${name}-color`, color);
        document.documentElement.style.setProperty(`--${name}-light`, this.lighten(color, 20));
        document.documentElement.style.setProperty(`--${name}-dark`, this.darken(color, 20));
        document.documentElement.style.setProperty(`--${name}-lighter`, this.lighten(color, 40));
        document.documentElement.style.setProperty(`--${name}-darker`, this.darken(color, 40));
    }


    lighten(color: string, percent: number): string {
        return tinycolor(color).lighten(percent).toString();
    }

    darken(color: string, percent: number): string {
        return tinycolor(color).darken(percent).toString();
    }

}
